import { Entry } from '../Entry'

export function Entry20241009() {
  return (
    <Entry title="09/10/2024 - v3.8.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16105/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
